import { render } from "./MovimientosView.vue?vue&type=template&id=7e5248c4&scoped=true"
import script from "./MovimientosView.vue?vue&type=script&lang=js"
export * from "./MovimientosView.vue?vue&type=script&lang=js"

import "./MovimientosView.vue?vue&type=style&index=0&id=7e5248c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e5248c4"]])

export default __exports__